/*
 * Copyright © 2025 TEKTELIC Communications Inc.
 */

import './dashboard.scss';
import { debounce } from 'lodash';

/*@ngInject*/
export default function DashboardController($window, $scope, $stateParams, $translate, $sce, types,
    entityService, grafanaService, entityTableConfiguration, toast) {
    var vm = this;

    vm.$onInit = function () {

        vm.gatewayGroupId = $stateParams.gatewayGroupId;
        vm.gatewayGroupName = entityTableConfiguration.getGatewayGroupName();
        vm.selectedGatewayGroups = [];
        vm.disabledSelect = true;

        vm.allGatewayGroups = [];
        vm.creatingDashboard = false;
        vm.grafanaIframeUrl = null;

        vm.createGrafanaDashboard = createGrafanaDashboard;
        vm.getTitle = getTitle;

        vm.onToggleSelectAll = onToggleSelectAll;
        vm.isAllGroupsSelected = isAllGroupsSelected;
        vm.getSelectLabel = getSelectLabel;

        if (vm.gatewayGroupId) {
            let entityId = {
                id: vm.gatewayGroupId,
                entityType: types.entityType.gateway_group
            }
            entityService.getEntity(entityId)
                .then((gatewayGroup) => {
                    vm.disabledSelect = true;
                    vm.selectedGatewayGroups = [gatewayGroup.id.id];
                });
        } else {
            entityService.getEntities(types.entityType.gateway_group).then(
                (gatewayGroups) => {
                    vm.disabledSelect = false;
                    vm.allGatewayGroups = gatewayGroups;
                    vm.allGatewayGroupIds = gatewayGroups.map(group => group.id.id);
                    vm.selectedGatewayGroups = vm.allGatewayGroupIds;
                }
            );
        }

        $scope.$watch('vm.selectedGatewayGroups', debounce((newVal, prevVal) => {
            if (newVal && newVal.length === 0) {
                vm.grafanaIframeUrl = null;
                vm.showWarning = true;
                return;
            }
            vm.showWarning = false;

            if (!angular.equals(newVal, prevVal)) {
                createGrafanaDashboard();
            }
        }, 1000));
    };

    function getTitle() {
        let title = $translate.instant('gateway.dashboard');
        if (vm.gatewayGroupName) {
            title = vm.gatewayGroupName + ': ' + title;
        }
        return title;
    }

    function createGrafanaDashboard() {
        vm.creatingDashboard = true;
        grafanaService.createGatewayGroupsDashboard(vm.selectedGatewayGroups).then(function (response) {
            vm.creatingDashboard = false;
            if (response && response.accessToken) {
                const url = 'https://' + $window.DynamicConfigs.appHost + '/grafana/public-dashboards/' + response.accessToken;
                vm.grafanaIframeUrl = $sce.trustAsResourceUrl(url);
            } else {
                toast.showError('Failed to create dashboard', 3000);
            }
        }).catch(function () {
            vm.creatingDashboard = false;
            toast.showError('Failed to create dashboard', 3000);
        });
    }

    function getSelectLabel() {
        if (!vm.selectedGatewayGroups.length) return "None selected";
        if (vm.selectedGatewayGroups.length === vm.allGatewayGroups.length) return 'All selected';
        if (vm.selectedGatewayGroups.length) return `${vm.selectedGatewayGroups.length} of ${vm.allGatewayGroups.length} selected`;
    }

    function isAllGroupsSelected() {
        return vm.selectedGatewayGroups.length === vm.allGatewayGroups.length
            && vm.allGatewayGroups.length > 0;
    }

    function onToggleSelectAll($event) {
        $event.stopPropagation();
        if (vm.isAllGroupsSelected()) {
            vm.selectedGatewayGroups = [];
        } else {
            vm.selectedGatewayGroups = angular.copy(vm.allGatewayGroupIds);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/gateway/dashboard/dashboard.controller.js